export default {
  control: {
    flex: 1,
  },

  group: {
    height: "calc(3 * var(--rhythm))",
  },

  button: {
    flexDirection: "column",
  },

  label: {
    display: "inline-flex",
    gap: "1ex",
    alignItems: "center",
    margin: "calc(0.5 * var(--rhythm)) 0",
  },

  description: {
    fontSize: "var(--font-size-xxs)",
    fontWeight: 400,
    lineHeight: 1,
    textTransform: "none",
    whiteSpace: "nowrap",
  },
};
